/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const WarningExclamatoryCircleFilledIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 24 24"
    onClick={props.onClick}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M11.499,1 C5.148,1 0,6.148 0,12.499 C0,18.85 5.148,23.998 11.499,23.998 C17.85,23.998 22.998,18.85 22.998,12.499 C22.998,6.148 17.85,1 11.499,1 Z M10.999,7 C11,6.724 11.224,6.5 11.5,6.5 C11.775,6.5 12,6.724 11.999,7 L11.999,14 C12,14.276 11.775,14.5 11.5,14.5 C11.224,14.5 11,14.276 10.999,14 L10.999,7 Z M11.518,18.5 C11.512,18.5 11.506,18.5 11.5,18.5 C10.955,18.5 10.509,18.065 10.5,17.518 C10.49,16.966 10.93,16.51 11.482,16.501 C11.488,16.501 11.494,16.5 11.5,16.5 C12.045,16.5 12.49,16.937 12.5,17.483 C12.51,18.035 12.068,18.49 11.518,18.5 Z" />
    </g>
  </svg>
);

export default WarningExclamatoryCircleFilledIcon;
